module.exports = __webpack_public_path__ + "img/gb13871-92_70x90x10.prt.647213ac.jpg";